import React, { useState } from 'react';
import {
  Mail,
  Lock,
  Sun,
  Moon,
  Check,
  KeyRound,
  ArrowRight,
  LayoutGrid,
  Users,
  Layers,
  ShieldCheck
} from 'lucide-react';
import { demoCredentials } from '../services/api';

// Reads /public/logo.png. If it isn't there yet, a text fallback is shown
// instead of a broken image so the layout never breaks.
function BrandLogo({ className, fallbackClassName }) {
  const [imgOk, setImgOk] = useState(true);

  if (!imgOk) {
    return <span className={fallbackClassName}>WiiZ</span>;
  }

  return (
    <img
      className={className}
      src="/AI_academy/logo.png"
      alt="Wiiz"
      onError={() => setImgOk(false)}
    />
  );
}

export default function AdminLogin({
  onLogin,
  onSwitchToPartner,
  theme,
  onToggleTheme
}) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState('');

  const submit = event => {
    event.preventDefault();
    setError('');

    if (
      email.trim().toLowerCase() === demoCredentials.admin.email &&
      password === demoCredentials.admin.password
    ) {
      onLogin({
        role: 'admin',
        name: 'Wiiz Admin',
        email: email.trim()
      });
      return;
    }

    setError('Invalid admin credentials.');
  };

  return (
    <div className="auth-shell">
      <div className="auth-page">
        <section className="auth-visual auth-visual-admin">
          <div className="auth-brand-line">
           <div className="auth-brand-mark">
  <span className="auth-brand-mark-fallback">W</span>
</div>
            <strong>WiiZ</strong>
            <span>Partner &amp; Certification Portal</span>
          </div>

          <div className="auth-copy">
            <span className="auth-kicker">ADMIN WORKSPACE</span>
            <h2>Manage. Allocate.<br />Deliver excellence.</h2>
            <p>
              Centralize courses, partners, allocations, requests and
              certificates in one secure workspace.
            </p>
          </div>

          <div className="auth-feature-list">
            <AuthFeature icon={<LayoutGrid size={15} />} title="Course &amp; certification" text="Create and manage learning content" />
            <AuthFeature icon={<Users size={15} />} title="Partner management" text="Create partners and manage access" />
            <AuthFeature icon={<Layers size={15} />} title="Allocation &amp; requests" text="Control assignments and approvals" />
            <AuthFeature icon={<ShieldCheck size={15} />} title="Secure &amp; scalable" text="Ready for Supabase integration" />
          </div>

          <div className="auth-trust">
            <span><Check size={11} /></span>
            <div>
              <b>UI-first development</b>
              <small>Mock data now. Supabase tables can be connected later.</small>
            </div>
          </div>
        </section>

        <div className="auth-card-wrap">
          <form className="auth-card auth-card-large" onSubmit={submit}>
            <div className="auth-card-top-row">
              <button
                className="auth-card-toggle"
                type="button"
                onClick={onToggleTheme}
                aria-label="Toggle theme"
              >
                {theme === 'light' ? <Sun size={11} /> : <Moon size={11} />}
                {theme === 'light' ? 'Light' : 'Dark'}
              </button>
              <span className="auth-secure">ADMIN ACCESS</span>
            </div>

            <div className="auth-card-logo">
              <span className="auth-card-logo-inner">
                <BrandLogo fallbackClassName="auth-card-logo-fallback" />
              </span>
            </div>

            <div className="auth-switch auth-switch-tabs">
              <button className="active" type="button">Admin Login</button>
              <button type="button" onClick={onSwitchToPartner}>Partner Login</button>
            </div>

            <span className="tag">SIGN IN</span>
            <h1>Welcome back</h1>
            <p className="auth-description">
              Enter your credentials to access your admin workspace.
            </p>

            <label>
              Work email
              <div className="input-with-icon">
                <span><Mail size={15} /></span>
                <input
                  type="email"
                  value={email}
                  placeholder="you@company.com"
                  onChange={event => setEmail(event.target.value)}
                  autoComplete="username"
                  required
                />
              </div>
            </label>

            <label>
              Password
              <div className="input-with-icon">
                <span><Lock size={15} /></span>
                <input
                  type="password"
                  value={password}
                  placeholder="••••••••"
                  onChange={event => setPassword(event.target.value)}
                  autoComplete="current-password"
                  required
                />
              </div>
            </label>


            {error && <div className="error auth-error">{error}</div>}

            <button className="primary full auth-submit" type="submit">
              Sign in
              <ArrowRight size={14} />
            </button>

            <p className="auth-footer-note">
              Access issues? Contact your system administrator.
            </p>

            {/* <div className="demo-box auth-demo">
              <span className="auth-demo-icon"><KeyRound size={14} /></span>
              <div>
                <b>UI-only demo</b>
                <span>{demoCredentials.admin.email} / {demoCredentials.admin.password}</span>
              </div>
            </div> */}
          </form>
        </div>
      </div>
    </div>
  );
}

function AuthFeature({ icon, title, text }) {
  return (
    <div className="auth-feature">
      <span className="auth-feature-icon">{icon}</span>
      <div>
        <b>{title}</b>
        <small>{text}</small>
      </div>
    </div>
  );
}